// extracted by mini-css-extract-plugin
module.exports = {"sidebar-offset":"_2YtwVTDF-AG-Z_r6_DaVMN","sidebarOffset":"_2YtwVTDF-AG-Z_r6_DaVMN","page-content":"_3Y8ndpEaI-zweVqX9gyl0L","pageContent":"_3Y8ndpEaI-zweVqX9gyl0L"};